<div class="card h-100 card-no-border mt-4">
    <div class="card-body">
        <cfg-table [resource]="templatesResource" [columns]="columns" [trackBy]="trackById"
            [searchFields]="['name', 'dbObjectName']" searchParam="search" searchStorageKey="templates"
            searchPlaceholder="Søg skabeloner..."
            [defaultSort]="defaultSort" [rowLink]="rowLink"
            emptyText="Ingen skabeloner at vise." loadingText="Indlæser skabeloner"
            errorText="Fejl under indlæsning af skabeloner." />
    </div>
</div>
